<template>
    <div class="questions-response">
        <div class="questions-response__icon">
            <IconCheckStatus v-if="success" />
            <IconCloseSmall v-else />
        </div>
        <h1
            class="questions-response__title"
            v-html="title" />

        <div
            class="questions-response__description"
            v-html="description" />
    </div>
</template>

<script>
import IconCheckStatus from '../../../components/Icons/CheckStatus.vue';
import IconCloseSmall from '../../../components/Icons/CloseSmall.vue';

export default {
    name: 'QuestionsResponse',

    components: {
        IconCheckStatus,
        IconCloseSmall
    },

    props: {
        success    : Boolean,
        title      : String,
        description: String
    }
};
</script>

<style lang="scss">
@import "QuestionsResponse";
</style>